import { useEffect, useState } from "react";

const toSeconds = (endTime) => {
    if (!endTime) return 0;
    const ms = new Date(endTime).getTime() - Date.now();
    return Math.max(0, Math.floor(ms / 1000));
};

export const useCountdownSeconds = (endTime) => {
    const [secondsLeft, setSecondsLeft] = useState(() => toSeconds(endTime));

    useEffect(() => {
        setSecondsLeft(toSeconds(endTime));
        const interval = setInterval(() => {
            const remaining = toSeconds(endTime);
            setSecondsLeft(remaining);
            if (remaining <= 0) clearInterval(interval);
        }, 1000);
        return () => clearInterval(interval);
    }, [endTime]);

    return secondsLeft;
};

export default useCountdownSeconds;